<h2 mat-dialog-title data-testid="create-payment-dialog-dialog-title">Confirm Payment Creation</h2>
<mat-divider></mat-divider>
<mat-dialog-content data-testid="create-payment-dialog-dialog-content">
  <p>
    Total fare has changed from
    <strong>{{ data.previousTotalFare | currency }}</strong> to
    <strong>{{ data.newTotalFare | currency }}</strong>
    (adjustment: <strong>{{ fareChange | currency }}</strong>).
  </p>

  <mat-divider style="margin: 12px 0"></mat-divider>
<form [formGroup]="form" data-testid="create-payment-dialog-confirmpopup">
  <p><strong>Create a Vendor payment for this fare change?</strong></p>
  <mat-radio-group formControlName="createVendorPayment" style="display: flex; gap: 16px;">
    <mat-radio-button value="yes" data-testid="create-vendor-payment-yes">Yes</mat-radio-button>
    <mat-radio-button value="no" data-testid="create-vendor-payment-no">No</mat-radio-button>
  </mat-radio-group>

  <mat-divider style="margin: 16px 0"></mat-divider>

  <p><strong>Create a Client (received) payment for this fare change?</strong></p>
  <mat-radio-group formControlName="createClientPayment" style="display: flex; gap: 16px;">
    <mat-radio-button value="yes" data-testid="create-client-payment-yes">Yes</mat-radio-button>
    <mat-radio-button value="no" data-testid="create-client-payment-no">No</mat-radio-button>
  </mat-radio-group>
  </form>
</mat-dialog-content>
<mat-divider></mat-divider>

<mat-dialog-actions align="end" data-testid="create-payment-dialog-dialog-actions">
  <button mat-button (click)="cancel()" data-testid="create-payment-dialog-cancel-button">Cancel</button>
  <button mat-raised-button color="primary" (click)="confirm()" [disabled]="form.invalid" data-testid="create-payment-dialog-confirm-button">Confirm</button>
</mat-dialog-actions>
